import { when } from '@execonline-inc/maybe-adapter';

export interface State {
  selectedCompetencyId: number;
}

export const setCompetencyId = (id: number): State => ({
  selectedCompetencyId: id,
});

export const activeComp = (state: State, id: number) =>
  when(state.selectedCompetencyId === id, {})
    .map(() => 'border-teal-600 bg-teal-600 text-white')
    .getOrElseValue('');
